import { inject, Injectable } from '@angular/core';
import * as Cesium from 'cesium';
import { BaseMapEntity } from './base-map-entity.service';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from './data-context.service';
import { TimelineService } from './timeline.service';
import { ThreeIntegrationService } from './three-js-building.service';

@Injectable({
  providedIn: 'root',
})
export class FacilityPinService {
  object: any;
  pocObject?: any;
  private two2Id = {
    iconUrl: 'assets/img/arcangel/facility3.png',
    iconSize: [32, 32],
  };

  constructor() {}

  // goToEntity(item: any): void {
  //   if (item && typeof item.goToEntity === 'function') {
  //     item.goToEntity();
  //   }
  // }
}
export class EntityMapEntity extends BaseMapEntity {
  constructor(
    mapEntityName: string,
    mapEntityLayerPath: string,
    cameraService: CameraService,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService
  ) {
    super(mapEntityName, mapEntityLayerPath,cameraService,coreService,windowService,dataContext,modalService,timelineService);
  }

  initialize(mapEntityName: string, mapEntityLayerPath: string): void {
    this.name = mapEntityName;
    this.layerPath = mapEntityLayerPath;
  }

  override buildEntity(): void {
    this.cesiumEntity = new Cesium.Entity({ name: this.name, id: this.id });
    this.cesiumEntity.arcLiveMapEntity = this;
  }
}

export class PushpinMapEntity extends EntityMapEntity {
  pushpinIcon: any;
  declare  cesiumEntity: any;

  constructor(
    mapEntityName: string,
    mapEntityLayerPath: string,
    icon: any,
    mapEntityLatitude: number,
    mapEntityLongitude: number,
    coreService: CoreService,
    windowService: WindowService,
      dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService,
    mapEntityAltitude?: number
  ) {
    super(mapEntityName, mapEntityLayerPath, icon,coreService,windowService,dataContext,modalService,timelineService);

    this.setCenterLatitude(mapEntityLatitude);
    this.setCenterLongitude(mapEntityLongitude);
    if (mapEntityAltitude !== undefined) {
      this.setCenterAltitude(mapEntityAltitude);
    } else {
      this.setCenterAltitude(0);
    }
    this.setPushpinIcon(icon, true);
  }

  getLatitude(): number {
    return this.getCenterLatitude() ?? 0;
  }

  getLongitude(): number {
    return this.getCenterLongitude() ?? 0;
  }

  getAltitude(): number {
    return this.getCenterAltitude() ?? 0;
  }

  setLatitude(latitude: number): void {
    this.setCenterLatitude(latitude);
    this.setPushpinPosition();
  }

  setLongitude(longitude: number): void {
    this.setCenterLongitude(longitude);
    this.setPushpinPosition();
  }

  setAltitude(altitude: number): void {
    this.setCenterAltitude(altitude);
    this.setPushpinPosition();
  }

  override buildEntity(): void {
    super.buildEntity();
    this.cesiumEntity.billboard = {};
    this.cesiumEntity.billboard.image = this.pushpinIcon;
    this.cesiumEntity.billboard.verticalOrigin = Cesium.VerticalOrigin.BOTTOM;
    this.setPushpinPosition();
    
  }

  setPushpinPosition(): void {
    if (this.cesiumEntity) {
      this.cesiumEntity.position = Cesium.Cartesian3.fromDegrees(
        this.getCenterLongitude() ?? 0,
        this.getCenterLatitude() ?? 0,
        this.getCenterAltitude() ?? 0
      );

      if (
        this.cesiumEntity.billboard &&
        (this.getCenterAltitude() === 0 || this.getCenterAltitude() === undefined)
      ) {
        this.cesiumEntity.billboard.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
      }
    }
  }

  override getCesiumEntity(): any {
    if (this.cesiumEntity === undefined) {
      this.buildEntity();
    }
    return this.cesiumEntity;
  }

  setPushpinIcon(icon: any, setMainIcon: boolean): void {
    if (icon === undefined) {
      const pinBuilder = new Cesium.PinBuilder();
      this.pushpinIcon = pinBuilder.fromColor(Cesium.Color.ROYALBLUE, 48).toDataURL();
    } else {
      if (setMainIcon) {
        this.setIcon(icon);
      }
      this.pushpinIcon = icon;
    }

    if (this.cesiumEntity !== undefined && this.cesiumEntity.billboard !== undefined) {
      this.cesiumEntity.billboard.image = this.pushpinIcon;
      this.cesiumEntity.billboard.scale = 1.0;
    }
  }
}
export class FacilityPinMapEntity extends PushpinMapEntity {
  object: any;
  pocObject: any = undefined;
  buildingMapEntity?: any;

  // 2D icon definition (for use with leaflet or similar)
  static two2Id = {
    iconUrl: 'assets/img/arcangel/facility3.png',
    iconSize: [32, 32],
  };
  safezones = [];
  updates = [];
  focalPoint = [];
  constructor(
    facilityName: string,
    mapEntityLatitude: number,
    mapEntityLongitude: number,
    object: any,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService,
    private threeJsBuildingIntegration: ThreeIntegrationService
  ) {
    super(
      facilityName,
      'ArcAngel//FacilityPins',
      object && object.locationType === 'campus' ? 'assets/img/icons/campus4.png' : 'assets/img/arcangel/facility4.png',
      mapEntityLatitude,
      mapEntityLongitude,
      coreService,
      windowService,
      dataContext,
      modalService, timelineService
    );
    this.setShowInLayersUI(false);
    this.object = object;
    this.setShowIn2d(true);
    
  }

  setBuildingMapEntity(buildingMapEntity: any): void {
    this.buildingMapEntity = buildingMapEntity;
  }
  
  getSafeZones() { return this.safezones; }
  getUpdates() { return this.updates; }
  getFocalPoint() { return this.focalPoint; }
  getBuildingMapEntity(): any {
    return this.buildingMapEntity;
  }
  override getWindowId(): any {
    if (this.buildingMapEntity) {
      return this.buildingMapEntity.getWindowId();
    }
    return this.windowId;
  }

  getPOC(): any {
    return this.object?.attributes?.poc;
  }

  getSOPs(): any {
    return this.object?.attributes?.sops;
  }

  getIsBluetooth(): boolean {
    return this.object?.attributes?.bluetooth;
  }

  getWeatherId(): any {
    return this.object?.attributes?.weatherIndicator;
  }

  getThreats(): any {
    return this.object?.attributes?.ratings;
  }

  getIntelReports(): any {
    return this.object?.attributes?.intel_reports;
  }

  override getShowIn3d(): boolean {
    return !this.getIsBluetooth();
  }

  getBasePerimeterId(): any {
    return this.object?.attributes?.basePerimeterId;
  }

  override get2dIcon(): any {
    return FacilityPinMapEntity.two2Id;
  }

  public override viewDetailsWindow(
    scope: any,
    positioning?: string,
    autoSize?: boolean,
    closeCallBack?: () => void,
    windowShape?: string
  ): void {
    if (this.buildingMapEntity) {
      this.buildingMapEntity.viewDetailsWindow(scope, positioning, autoSize, closeCallBack, windowShape);
      if (scope.object && scope.object.locationType === 'campus') {
        if (this.buildingMapEntity) {
          this.threeJsBuildingIntegration.openBuilding(this.buildingMapEntity);
        }
      }
    } else {
      const data: any = {
        facilityId: this.object?.id,
        facilityAddress: this.object?.attributes?.address,
        orgId: this.object?.organizationId
      };
      // Assume UserService is available globally for now
      if ((window as any).UserService?.methods?.getUserProfile) {
        (window as any).UserService.methods.getUserProfile(this.object?.attributes?.poc)
          .then((result: any) => {
            if (typeof result === 'object') {
              data.pocName = result.getName?.();
              data.pocTitle = result.attributes?.title;
              data.pocEmail = result.getEmail?.();
              if (result.attributes?.workPhone) {
                data.pocNumber = result.attributes.workPhone.number;
              }
              data.pocId = result.arcAngelId;
            }
            if ((window as any).WindowService?.openModalWindow) {
              return (window as any).WindowService.openModalWindow(
                data,
                'FacilityBaseballCardDialogController',
                'components/arcangel/facilities/facility-info-dialog.html'
              );
            }
          })
          .catch((error: any) => {
            console.error('Error getting user profile.', error);
          });
      } else {
        console.error('UserService.methods.getUserProfile not available');
      }
    }
  }
}

export class SessionOption {
  constructor(
    public mode: string,
    public event: EventOption,
    public byPassPin: boolean,
    public suppressReset: boolean
  ) {}
}
export class EventOption {
  constructor(
    public incidentId: string,
    public type: string
  ) {}
}

export class PrimitiveMapEntity extends BaseMapEntity {
  constructor(
    mapEntityName: string,
    mapEntityLayerPath: string,
    cameraService: CameraService,
    coreService: CoreService,
    windowService: WindowService,
      dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService
  ) {
    super(mapEntityName, mapEntityLayerPath,cameraService,coreService,windowService,dataContext,modalService,timelineService);
  }

  override buildEntity(): void {
    this.cesiumEntity = new Cesium.Primitive({});
    // Optionally set arcLiveMapEntity here if needed
    this.cesiumEntity.arcLiveMapEntity = this;
  }

  override isPrimitive(): boolean {
    return true;
  }

  override async goToEntity(goToEntityCallback?: () => void): Promise<void> {
    // TODO: Inject and use Camera service if available
    // For now, just a placeholder for camera flyTo logic
    // Camera.flyTo(this.getFlyToOptions());
    if (goToEntityCallback) {
      goToEntityCallback();
    }
  }

  getFlyToOptions(): any {
    return {
      destination: Cesium.Cartesian3.fromDegrees(
        this.getCenterLongitude() ?? 0,
        this.getCenterLatitude() ?? 0,
        500
      ),
      duration: 3,
      complete: function () {}
    };
  }
}